/**
 * Who can edit an app, and the invitations that got them there.
 *
 * Web-owned for the same reason as the rest: the shared store reaches CognitoService.
 */
import type { AppMember, AppRole } from '@/backend/types';
import { request } from './client';

export interface AppInvite {
  token: string;
  email?: string;
  role: AppRole;
  expiresAt?: string;
}

export async function fetchMembers(appId: string): Promise<AppMember[]> {
  const body = await request<{ items?: AppMember[] }>(`/apps/${encodeURIComponent(appId)}/members`);
  return body.items ?? [];
}

export async function inviteMember(
  appId: string,
  input: { email?: string; phone?: string; role: AppRole },
): Promise<AppInvite> {
  return request<AppInvite>(`/apps/${encodeURIComponent(appId)}/invites`, { method: 'POST', body: input });
}

/** Accepting is bound to the invited address and to a non-expired invite, server-side. */
export async function acceptInvite(token: string): Promise<{ appId: string; role: AppRole }> {
  return request<{ appId: string; role: AppRole }>(`/invites/${encodeURIComponent(token)}/accept`, {
    method: 'POST',
  });
}

export async function setMemberRole(appId: string, userId: string, role: AppRole): Promise<void> {
  await request(`/apps/${encodeURIComponent(appId)}/members/${encodeURIComponent(userId)}`, {
    method: 'PUT',
    body: { role },
  });
}

export async function removeMember(appId: string, userId: string): Promise<void> {
  await request(`/apps/${encodeURIComponent(appId)}/members/${encodeURIComponent(userId)}`, {
    method: 'DELETE',
  });
}
